export default __webpack_public_path__ + "static/media/Ballroll_00046.9f110657.png";